import { SystemText } from 'e4shared';
import React from 'react';
import { Link } from 'react-router-dom';

const TaskPathwaySection = props => {
    const { task } = props;

    return task.date_Completed ? (
        <div className="col-md-12">
            <h4 className="flex flex-center">
                <i className="fa fa-check-circle text-success mr10" />
                <div>
                    {SystemText('Objectives/Pathways/Completed')}{' '}
                    {task.pathway && (
                        <Link to={`/develop/pathways/${task.profile_Id}?id=${task.pathway_Assignment_Id}`}>
                            {task.pathway}
                        </Link>
                    )}
                </div>
            </h4>
        </div>
    ) : (
        <div className="col-md-12">
            <h4 className="flex flex-center">
                <i className="fa fa-warning text-danger mr10" />
                <div>
                    {SystemText('Objectives/Pathways/NotCompleted')}{' '}
                    {task.pathway && (
                        <Link to={`/develop/pathways/${task.profile_Id}?id=${task.pathway_Assignment_Id}`}>
                            {task.pathway}
                        </Link>
                    )}
                </div>
            </h4>
        </div>
    );
};

export default TaskPathwaySection;
